import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, createSlots as _createSlots } from "vue";
const _hoisted_1 = {
  class: "controls px-6 py-2",
  "data-cy": "users-page"
};
const _hoisted_2 = {
  class: "flex items-center justify-between mb-2"
};
const _hoisted_3 = {
  class: "flex gap-2"
};
const _hoisted_4 = {
  class: "border-b border-gray-200 mb-4"
};
const _hoisted_5 = {
  class: "fa fa-user"
};
const _hoisted_6 = {
  class: "fa fa-check"
};
const _hoisted_7 = {
  class: "fa fa-check"
};
const _hoisted_8 = {
  class: "fa fa-user"
};
const _hoisted_9 = {
  class: "fa fa-check"
};
const _hoisted_10 = {
  class: "fa fa-check"
};
const _hoisted_11 = {
  class: "flex items-center justify-end gap-2 mb-3"
};
const _hoisted_12 = {
  class: "overflow-x-auto"
};
const _hoisted_13 = ["data-cy"];
import { reactive, ref, computed, onMounted, watch } from 'vue';
import axios from 'axios';
import LlTooltip from '@/components/LlTooltip.vue';
import LlTextField from '@/components/LlTextField.vue';
import LlSelect from '@/components/LlSelect.vue';
import LlCheckbox from '@/components/LlCheckbox.vue';
import MainHeader from '@/components/MainHeader.vue';
import CompanyUserInfo from './CompanyUser/CompanyUserInfo.vue';
import EditUserRate from './CompanyUser/EditUserRate.vue';
import UserEditPanel from './CompanyUser/UserEditPanel.vue';
import SnackbarComponent from '@/components/SnackbarComponent.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlTabs from '@/components/LlTabs.vue';
import { useMeStore } from '@/services/UserService/useMeStore';
import { storeToRefs } from 'pinia';
import { useAccountsStore } from '@/services/UserService/useAccountsStore';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import { useCustomFieldsStore } from './CustomFields/useCustomFieldsStore';
import ListsService from '@/services/ListsService';
export default {
  __name: 'CompanyUsers',
  props: {
    state: {
      type: Object,
      required: false
    },
    stateParams: {
      type: Object,
      required: false
    }
  },
  setup(__props) {
    const {
      getMe
    } = useMeStore();
    const {
      loadMyCompany
    } = useCompanyStore();
    const {
      me,
      features
    } = storeToRefs(useMeStore());
    const {
      subscription
    } = storeToRefs(useCompanyStore());
    const customFieldsStore = useCustomFieldsStore();
    const props = __props;
    const accountsStore = useAccountsStore();
    const {
      handleError,
      handleSuccess
    } = useSnackbarHandler();
    const listsService = new ListsService();

    // --- Page-level tabs ---
    const activePageTab = ref('active');
    const companyUserState = reactive({
      loading: true,
      allUsers: [],
      showUserInfoModal: false,
      showEditRateModal: false,
      showUserPanel: false,
      initialTab: 'details',
      panelMode: 'invite',
      modalTriggerType: '',
      selectedUser: {},
      roles: []
    });

    // Custom field state
    const userCustomFieldDefs = ref([]);
    const customFieldValuesMap = reactive({});
    const customFieldSnapshot = ref(null);
    const savingCustomFields = ref(false);
    const bulkEditMode = ref(false);
    const showInactiveUsers = ref(false);
    const loadingInactiveCustomFields = ref(false);
    const defaultSort = [{
      key: 'last',
      order: 'asc'
    }];
    const tableHeaders = [{
      title: '',
      key: 'meIcon',
      sortable: false,
      width: '40px'
    }, {
      title: 'First',
      key: 'first',
      sortable: true
    }, {
      title: 'Last',
      key: 'last',
      sortable: true
    }, {
      title: 'Initials',
      key: 'initials',
      sortable: true
    }, {
      title: 'Status',
      key: 'registration',
      sortable: true
    }, {
      title: 'Role',
      key: 'role',
      sortable: true
    }, {
      title: 'Setup',
      key: 'setup',
      sortable: false
    }, {
      title: 'Include',
      key: 'include',
      sortable: false
    }];
    const activeUsers = computed(() => companyUserState.allUsers.filter(a => !a.disabled));
    const inactiveUsers = computed(() => companyUserState.allUsers.filter(a => a.disabled));
    const showCustomFieldsTab = computed(() => features.value?.customFieldMapping && userCustomFieldDefs.value.length > 0);
    const pageTabs = computed(() => {
      const tabs = [{
        value: 'active',
        label: 'Active Users',
        dataCy: 'page-tab-active'
      }, {
        value: 'inactive',
        label: 'Inactive Users',
        dataCy: 'page-tab-inactive'
      }];
      if (showCustomFieldsTab.value) {
        tabs.push({
          value: 'customFields',
          label: 'Custom Fields',
          dataCy: 'page-tab-customFields'
        });
      }
      return tabs;
    });

    // Custom field table headers: name, role, initials + one per custom field
    const customFieldTableHeaders = computed(() => {
      const headers = [{
        title: 'First',
        key: 'first',
        sortable: true
      }, {
        title: 'Last',
        key: 'last',
        sortable: true
      }, {
        title: 'Initials',
        key: 'initials',
        sortable: true
      }, {
        title: 'Role',
        key: 'role',
        sortable: true
      }];
      for (const field of userCustomFieldDefs.value) {
        headers.push({
          title: field.name || field.label,
          key: `cf_${field.id}`,
          sortable: false,
          minWidth: '160px'
        });
      }
      return headers;
    });
    const customFieldRows = computed(() => showInactiveUsers.value ? [...activeUsers.value, ...inactiveUsers.value] : activeUsers.value);
    const customFieldsDirty = computed(() => {
      if (!customFieldSnapshot.value) return false;
      return JSON.stringify(customFieldValuesMap) !== customFieldSnapshot.value;
    });
    const userName = computed(() => `${companyUserState.selectedUser.first} ${companyUserState.selectedUser.last}`);

    // --- Custom field helpers ---
    const fieldType = field => {
      const t = field.fieldType || field.type;
      if (typeof t === 'string') return t.toLowerCase();
      const map = {
        0: 'text',
        1: 'number',
        2: 'date',
        3: 'boolean',
        4: 'enum'
      };
      return map[t] || 'text';
    };
    const getCustomFieldValue = (userId, fieldId, type) => {
      const key = `${userId}_${fieldId}`;
      const entry = customFieldValuesMap[key];
      if (!entry) return type === 'number' ? null : '';
      if (type === 'text') return entry.textValue || '';
      if (type === 'number') return entry.numberValue;
      if (type === 'enum') return entry.enumValueId || null;
      return '';
    };
    const displayCustomFieldValue = (userId, field) => {
      const type = fieldType(field);
      const val = getCustomFieldValue(userId, field.id, type);
      if (val == null || val === '') return '-';
      if (type === 'enum') {
        const opt = (field.enumOptions || []).find(o => o.id === val);
        return opt?.label || val;
      }
      return val;
    };
    const setCustomFieldValue = (userId, fieldId, type, value) => {
      const key = `${userId}_${fieldId}`;
      if (!customFieldValuesMap[key]) {
        customFieldValuesMap[key] = {
          userId,
          fieldId
        };
      }
      if (type === 'text') customFieldValuesMap[key].textValue = value;
      if (type === 'number') customFieldValuesMap[key].numberValue = value;
      if (type === 'enum') customFieldValuesMap[key].enumValueId = value;
    };
    const loadAllUserCustomFields = async () => {
      // Load custom field definitions
      await customFieldsStore.listCustomFields();
      const defs = customFieldsStore.userFields || [];
      userCustomFieldDefs.value = defs.filter(f => f.active !== false);
      if (!userCustomFieldDefs.value.length) return;
      await loadUserCustomFieldValues(customFieldRows.value);
      customFieldSnapshot.value = JSON.stringify(customFieldValuesMap);
    };
    const loadUserCustomFieldValues = async users => {
      const CONCURRENCY = 10;
      for (let i = 0; i < users.length; i += CONCURRENCY) {
        const chunk = users.slice(i, i + CONCURRENCY);
        // Fetch a chunk of users in parallel; ignore individual failures
        await Promise.all(chunk.map(async user => {
          try {
            const {
              data
            } = await axios.get(`/accounts/${user.id}/customFields`);
            const fields = data.customFields || [];
            for (const cf of fields) {
              const key = `${user.id}_${cf.customField.id}`;
              customFieldValuesMap[key] = {
                userId: user.id,
                fieldId: cf.customField.id,
                textValue: cf.textValue || '',
                numberValue: cf.numberValue,
                enumValueId: cf.enumValue?.id || null
              };
            }
          } catch {
            // Skip users whose custom fields can't be loaded
          }
        }));
      }
    };

    // The toggle is disabled while there are unsaved edits, so re-snapshotting the
    // whole map here can't swallow a pending change.
    watch(showInactiveUsers, async show => {
      if (!show || !userCustomFieldDefs.value.length) return;
      loadingInactiveCustomFields.value = true;
      try {
        await loadUserCustomFieldValues(inactiveUsers.value);
        customFieldSnapshot.value = JSON.stringify(customFieldValuesMap);
      } finally {
        loadingInactiveCustomFields.value = false;
      }
    });
    const cancelBulkEdit = () => {
      // Revert to snapshot
      if (customFieldSnapshot.value) {
        const snapshotData = JSON.parse(customFieldSnapshot.value);
        // Clear current values
        for (const key of Object.keys(customFieldValuesMap)) {
          delete customFieldValuesMap[key];
        }
        // Restore snapshot values
        Object.assign(customFieldValuesMap, snapshotData);
      }
      bulkEditMode.value = false;
    };
    const saveAllCustomFields = async () => {
      savingCustomFields.value = true;
      try {
        const snapshot = customFieldSnapshot.value ? JSON.parse(customFieldSnapshot.value) : {};

        // Only collect users/fields that actually changed
        const userChanges = {};
        for (const [key, entry] of Object.entries(customFieldValuesMap)) {
          const prev = snapshot[key];
          const fieldDef = userCustomFieldDefs.value.find(f => f.id === entry.fieldId);
          const type = fieldDef ? fieldType(fieldDef) : 'text';

          // Compare current value to snapshot
          let changed = false;
          if (!prev) {
            // New entry that didn't exist before
            changed = true;
          } else if (type === 'text' && (entry.textValue || '') !== (prev.textValue || '')) {
            changed = true;
          } else if (type === 'number' && entry.numberValue !== prev.numberValue) {
            changed = true;
          } else if (type === 'enum' && (entry.enumValueId || null) !== (prev.enumValueId || null)) {
            changed = true;
          }
          if (changed) {
            const {
              userId,
              fieldId
            } = entry;
            if (!userChanges[userId]) userChanges[userId] = [];
            userChanges[userId].push({
              id: fieldId,
              textValue: type === 'text' ? entry.textValue : undefined,
              numberValue: type === 'number' ? entry.numberValue : undefined,
              enumValueId: type === 'enum' ? entry.enumValueId : undefined
            });
          }
        }
        const savePromises = Object.entries(userChanges).map(([userId, fields]) => axios.put(`/accounts/${userId}/customFields`, {
          customFields: fields
        }));
        await Promise.all(savePromises);
        customFieldSnapshot.value = JSON.stringify(customFieldValuesMap);
        bulkEditMode.value = false;
        handleSuccess('Custom fields saved successfully');
      } catch (error) {
        handleError(error);
      } finally {
        savingCustomFields.value = false;
      }
    };

    // --- Lifecycle ---
    onMounted(async () => {
      try {
        companyUserState.loading = true;
        await Promise.all([getMe(), loadMyCompany(), refetchUserList()]);
        companyUserState.roles = listsService.getUserRoles('ledes1998');
      } catch (error) {
        handleError(error);
      } finally {
        companyUserState.loading = false;
      }

      // Load custom field definitions (non-blocking)
      if (features.value?.customFieldMapping) {
        loadAllUserCustomFields().catch(() => {});
      }

      // Deep linking: open panel from URL params after data is loaded
      const panelParam = props.state?.params?.panel;
      if (panelParam) {
        const userId = props.state?.params?.userId || null;
        const tab = props.state?.params?.tab || 'details';
        if (panelParam === 'edit' && userId) {
          companyUserState.selectedUser = {
            id: userId
          };
        } else {
          companyUserState.selectedUser = {};
        }
        companyUserState.initialTab = tab;
        companyUserState.panelMode = panelParam === 'accountant' ? 'accountant' : 'invite';
        companyUserState.showUserPanel = true;
      }
    });
    const updateUrl = (panel, userId, tab) => {
      if (props.state) {
        props.state.go('settings.company.users', {
          panel,
          userId,
          tab
        }, {
          notify: false,
          reload: false
        });
      }
    };
    const edit = user => {
      if (features.value?.userEditPanel) {
        companyUserState.selectedUser = user || {};
        companyUserState.initialTab = 'details';
        companyUserState.panelMode = 'invite';
        companyUserState.showUserPanel = true;
        updateUrl(user ? 'edit' : 'invite', user?.id || null, null);
      } else {
        companyUserState.selectedUser = user || {};
        companyUserState.modalTriggerType = user ? 'edit' : 'invite';
        companyUserState.showUserInfoModal = true;
      }
    };
    const closeUserPanel = () => {
      companyUserState.showUserPanel = false;
      companyUserState.selectedUser = {};
      updateUrl(null, null, null);
    };
    const handlePanelSaved = async () => {
      companyUserState.showUserPanel = false;
      companyUserState.loading = true;
      await refetchUserList();
      companyUserState.loading = false;
      companyUserState.selectedUser = {};
      updateUrl(null, null, null);
      // Reload custom field values so the bulk-edit tab reflects any changes
      if (features.value?.customFieldMapping) {
        loadAllUserCustomFields().catch(() => {});
      }
    };
    const handleTabChange = tab => {
      const panel = props.state?.params?.panel || (companyUserState.selectedUser?.id ? 'edit' : 'invite');
      const userId = companyUserState.selectedUser?.id || null;
      updateUrl(panel, userId, tab);
    };
    const addAccountingPartner = () => {
      if (features.value?.userEditPanel) {
        companyUserState.selectedUser = {};
        companyUserState.initialTab = 'details';
        companyUserState.panelMode = 'accountant';
        companyUserState.showUserPanel = true;
        updateUrl('accountant', null, null);
      } else {
        companyUserState.selectedUser = {};
        companyUserState.modalTriggerType = 'invite';
        companyUserState.showUserInfoModal = true;
      }
    };
    const editRates = user => {
      companyUserState.selectedUser = user;
      companyUserState.showEditRateModal = true;
    };
    const refetchUserList = async () => {
      const accounts = await accountsStore.listAccounts(true, {
        status: 'all'
      });
      companyUserState.allUsers = accounts;
    };
    const closeUserInfoModal = () => {
      companyUserState.showUserInfoModal = false;
      companyUserState.selectedUser = {};
    };
    const editOrInviteSuccess = async () => {
      companyUserState.showUserInfoModal = false;
      companyUserState.loading = true;
      await refetchUserList();
      companyUserState.loading = false;
    };
    const updateUserRate = async rates => {
      await accountsStore.updateAccount(companyUserState.selectedUser.id, rates);
      companyUserState.showEditRateModal = false;
      companyUserState.showUserInfoModal = false;
      companyUserState.loading = true;
      await refetchUserList();
      companyUserState.loading = false;
      companyUserState.selectedUser = {};
    };
    const status = user => {
      if (user.disabled) return 'Disabled';
      if (user.registered) return 'Registered';
      if (user.invitation) return 'Invited';
      return '-';
    };
    const roleDescription = user => {
      if (user) {
        const roleLabel = companyUserState?.roles.find(role => role.id === user.role);
        return roleLabel?.label;
      }
      return '';
    };
    return (_ctx, _cache) => {
      const _component_v_dialog = _resolveComponent("v-dialog");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
      const _component_v_data_table = _resolveComponent("v-data-table");
      const _component_v_chip = _resolveComponent("v-chip");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(SnackbarComponent, {
        ref: "snackbar"
      }, null, 512), _createVNode(UserEditPanel, {
        modelValue: companyUserState.showUserPanel,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => companyUserState.showUserPanel = $event),
        userId: companyUserState.selectedUser?.id,
        initialTab: companyUserState.initialTab,
        mode: companyUserState.panelMode,
        onClose: closeUserPanel,
        onSaved: handlePanelSaved,
        onTabChange: handleTabChange
      }, null, 8, ["modelValue", "userId", "initialTab", "mode"]), companyUserState.showUserInfoModal ? (_openBlock(), _createBlock(_component_v_dialog, {
        key: 0,
        modelValue: companyUserState.showUserInfoModal,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => companyUserState.showUserInfoModal = $event),
        width: "800",
        "data-cy": "user-info-modal"
      }, {
        default: _withCtx(() => [_createVNode(CompanyUserInfo, {
          type: companyUserState.modalTriggerType,
          userInfo: companyUserState.selectedUser,
          onConfirm: editOrInviteSuccess,
          onCancel: closeUserInfoModal
        }, null, 8, ["type", "userInfo"])]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true), companyUserState.showEditRateModal ? (_openBlock(), _createBlock(_component_v_dialog, {
        key: 1,
        modelValue: companyUserState.showEditRateModal,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => companyUserState.showEditRateModal = $event),
        width: "400",
        "data-cy": "edit-rate-modal"
      }, {
        default: _withCtx(() => [_createVNode(EditUserRate, {
          userName: userName.value,
          existingRates: companyUserState.selectedUser.rates,
          onCancel: _cache[2] || (_cache[2] = $event => companyUserState.showEditRateModal = false),
          onSave: updateUserRate
        }, null, 8, ["userName", "existingRates"])]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_2, [_createVNode(MainHeader, {
        content: "Users",
        "data-cy": "users-header"
      }), _createElementVNode("div", _hoisted_3, [_createVNode(LlSecondaryButton, {
        "data-cy": "invite-user-button",
        color: "primary",
        onClick: _cache[4] || (_cache[4] = _withModifiers($event => edit(), ["prevent"]))
      }, {
        default: _withCtx(() => [_createVNode(_component_v_icon, {
          class: "mr-1"
        }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("mdi-email", -1)]))]),
          _: 1
        }), _cache[12] || (_cache[12] = _createTextVNode("Invite User ", -1))]),
        _: 1
      }), _createVNode(LlSecondaryButton, {
        "data-cy": "add-accounting-partner-button",
        onClick: _cache[5] || (_cache[5] = _withModifiers($event => addAccountingPartner(), ["prevent"]))
      }, {
        default: _withCtx(() => [_createVNode(_component_v_icon, {
          class: "mr-1"
        }, {
          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode("mdi-email", -1)]))]),
          _: 1
        }), _cache[14] || (_cache[14] = _createTextVNode("Add Accounting Partner ", -1))]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_4, [_createVNode(LlTabs, {
        modelValue: activePageTab.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => activePageTab.value = $event),
        items: pageTabs.value
      }, null, 8, ["modelValue", "items"])]), companyUserState.loading ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
        key: 0,
        type: "table-thead, table-tbody, table-tbody",
        "data-cy": "users-table-loading"
      })) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_v_data_table, {
        headers: tableHeaders,
        items: activeUsers.value,
        "hide-default-footer": "",
        "items-per-page": -1,
        "must-sort": "",
        "fixed-header": "",
        height: activeUsers.value.length > 10 ? '70vh' : 'auto',
        class: "table-striped",
        "data-cy": "active-users-table",
        "sort-by": defaultSort,
        "row-props": ({
          item
        }) => ({
          class: {
            'cursor-pointer': true,
            success: item.justAdded
          },
          'data-cy': `active-user-row-${item.id}`
        }),
        "onClick:row": _cache[7] || (_cache[7] = (event, {
          item
        }) => edit(item))
      }, {
        [`item.meIcon`]: _withCtx(({
          item
        }) => [_withDirectives(_createElementVNode("span", _hoisted_5, null, 512), [[_vShow, item.id === _unref(me).id]])]),
        [`item.initials`]: _withCtx(({
          item
        }) => [_createTextVNode(_toDisplayString(item.initials || '-'), 1)]),
        [`item.registration`]: _withCtx(({
          item
        }) => [_createTextVNode(_toDisplayString(status(item)), 1)]),
        [`item.role`]: _withCtx(({
          item
        }) => [_createTextVNode(_toDisplayString(roleDescription(item)), 1)]),
        [`item.setup`]: _withCtx(({
          item
        }) => [_withDirectives(_createElementVNode("span", _hoisted_6, null, 512), [[_vShow, item.access?.setup]])]),
        [`item.include`]: _withCtx(({
          item
        }) => [_withDirectives(_createElementVNode("span", _hoisted_7, null, 512), [[_vShow, item.access?.include]])]),
        [`header.setup`]: _withCtx(({
          column
        }) => [_createTextVNode(_toDisplayString(column.title) + " ", 1), _createVNode(LlTooltip, {
          icon: "help"
        }, {
          default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("This user has access to setup features for the firm (inviting users etc)", -1)]))]),
          _: 1
        })]),
        [`header.include`]: _withCtx(({
          column
        }) => [_createTextVNode(_toDisplayString(column.title) + " ", 1), _createVNode(LlTooltip, {
          icon: "help"
        }, {
          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("If selected, the user will be added automatically to all new matters that are created", -1)]))]),
          _: 1
        })]),
        _: 2
      }, 1032, ["items", "height", "row-props"])], 512), [[_vShow, activePageTab.value === 'active' && !companyUserState.loading]]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_v_data_table, {
        headers: tableHeaders,
        items: inactiveUsers.value,
        "hide-default-footer": "",
        "items-per-page": -1,
        "must-sort": "",
        "fixed-header": "",
        height: inactiveUsers.value.length > 10 ? '70vh' : 'auto',
        class: "table-striped",
        "data-cy": "inactive-users-table",
        "sort-by": defaultSort,
        "row-props": ({
          item
        }) => ({
          class: {
            'cursor-pointer': true
          },
          'data-cy': `inactive-user-row-${item.id}`
        }),
        "onClick:row": _cache[8] || (_cache[8] = (event, {
          item
        }) => edit(item))
      }, {
        [`item.meIcon`]: _withCtx(({
          item
        }) => [_withDirectives(_createElementVNode("span", _hoisted_8, null, 512), [[_vShow, item.id === _unref(me).id]])]),
        [`item.initials`]: _withCtx(({
          item
        }) => [_createTextVNode(_toDisplayString(item.initials || '-'), 1)]),
        [`item.registration`]: _withCtx(({
          item
        }) => [_createTextVNode(_toDisplayString(status(item)), 1)]),
        [`item.role`]: _withCtx(({
          item
        }) => [_createTextVNode(_toDisplayString(roleDescription(item)), 1)]),
        [`item.setup`]: _withCtx(({
          item
        }) => [_withDirectives(_createElementVNode("span", _hoisted_9, null, 512), [[_vShow, item.access?.setup]])]),
        [`item.include`]: _withCtx(({
          item
        }) => [_withDirectives(_createElementVNode("span", _hoisted_10, null, 512), [[_vShow, item.access?.include]])]),
        [`header.setup`]: _withCtx(({
          column
        }) => [_createTextVNode(_toDisplayString(column.title) + " ", 1), _createVNode(LlTooltip, {
          icon: "help"
        }, {
          default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("This user has access to setup features for the firm (inviting users etc)", -1)]))]),
          _: 1
        })]),
        [`header.include`]: _withCtx(({
          column
        }) => [_createTextVNode(_toDisplayString(column.title) + " ", 1), _createVNode(LlTooltip, {
          icon: "help"
        }, {
          default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode("If selected, the user will be added automatically to all new matters that are created", -1)]))]),
          _: 1
        })]),
        _: 2
      }, 1032, ["items", "height", "row-props"])], 512), [[_vShow, activePageTab.value === 'inactive' && !companyUserState.loading]]), _withDirectives(_createElementVNode("div", null, [_createElementVNode("div", _hoisted_11, [_createVNode(LlCheckbox, {
        modelValue: showInactiveUsers.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => showInactiveUsers.value = $event),
        label: "Show inactive users",
        disabled: loadingInactiveCustomFields.value || savingCustomFields.value || customFieldsDirty.value,
        class: "mr-auto",
        "data-cy": "show-inactive-users-checkbox"
      }, null, 8, ["modelValue", "disabled"]), bulkEditMode.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(LlSecondaryButton, {
        color: "primary",
        loading: savingCustomFields.value,
        disabled: savingCustomFields.value || !customFieldsDirty.value,
        onClick: saveAllCustomFields,
        "data-cy": "save-custom-fields-btn"
      }, {
        default: _withCtx(() => [...(_cache[19] || (_cache[19] = [_createTextVNode(" Save ", -1)]))]),
        _: 1
      }, 8, ["loading", "disabled"]), _createVNode(LlSecondaryButton, {
        disabled: savingCustomFields.value,
        onClick: cancelBulkEdit,
        "data-cy": "cancel-custom-fields-btn"
      }, {
        default: _withCtx(() => [...(_cache[20] || (_cache[20] = [_createTextVNode(" Cancel ", -1)]))]),
        _: 1
      }, 8, ["disabled"])], 64)) : (_openBlock(), _createBlock(LlSecondaryButton, {
        key: 1,
        onClick: _cache[10] || (_cache[10] = $event => bulkEditMode.value = true),
        "data-cy": "bulk-edit-btn"
      }, {
        default: _withCtx(() => [...(_cache[21] || (_cache[21] = [_createTextVNode(" Bulk Edit ", -1)]))]),
        _: 1
      }))]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_v_data_table, {
        headers: customFieldTableHeaders.value,
        items: customFieldRows.value,
        "hide-default-footer": "",
        "items-per-page": -1,
        "must-sort": "",
        "fixed-header": "",
        height: customFieldRows.value.length > 10 ? '70vh' : 'auto',
        class: "table-striped",
        "data-cy": "custom-fields-table",
        "sort-by": defaultSort
      }, _createSlots({
        [`item.last`]: _withCtx(({
          item
        }) => [_createTextVNode(_toDisplayString(item.last) + " ", 1), item.disabled ? (_openBlock(), _createBlock(_component_v_chip, {
          key: 0,
          size: "x-small",
          class: "ml-1",
          "data-cy": `custom-fields-inactive-chip-${item.id}`
        }, {
          default: _withCtx(() => [...(_cache[22] || (_cache[22] = [_createTextVNode(" Inactive ", -1)]))]),
          _: 1
        }, 8, ["data-cy"])) : _createCommentVNode("", true)]),
        [`item.role`]: _withCtx(({
          item
        }) => [_createTextVNode(_toDisplayString(roleDescription(item)), 1)]),
        [`item.initials`]: _withCtx(({
          item
        }) => [_createTextVNode(_toDisplayString(item.initials || '-'), 1)]),
        _: 2
      }, [_renderList(userCustomFieldDefs.value, field => {
        return {
          name: `item.cf_${field.id}`,
          fn: _withCtx(({
            item
          }) => [!bulkEditMode.value ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            "data-cy": `cf-${field.id}-user-${item.id}-display`
          }, _toDisplayString(displayCustomFieldValue(item.id, field)), 9, _hoisted_13)) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [fieldType(field) === 'text' ? (_openBlock(), _createBlock(LlTextField, {
            key: 0,
            "model-value": getCustomFieldValue(item.id, field.id, 'text'),
            "onUpdate:modelValue": $event => setCustomFieldValue(item.id, field.id, 'text', $event),
            "hide-details": "",
            density: "compact",
            class: "my-1",
            "data-cy": `cf-${field.id}-user-${item.id}`
          }, null, 8, ["model-value", "onUpdate:modelValue", "data-cy"])) : fieldType(field) === 'number' ? (_openBlock(), _createBlock(LlTextField, {
            key: 1,
            "model-value": getCustomFieldValue(item.id, field.id, 'number'),
            "onUpdate:modelValue": $event => setCustomFieldValue(item.id, field.id, 'number', $event),
            type: "number",
            "hide-details": "",
            density: "compact",
            class: "my-1",
            "data-cy": `cf-${field.id}-user-${item.id}`
          }, null, 8, ["model-value", "onUpdate:modelValue", "data-cy"])) : fieldType(field) === 'enum' ? (_openBlock(), _createBlock(LlSelect, {
            key: 2,
            "model-value": getCustomFieldValue(item.id, field.id, 'enum'),
            "onUpdate:modelValue": $event => setCustomFieldValue(item.id, field.id, 'enum', $event),
            items: field.enumOptions || [],
            "item-title": "label",
            "item-value": "id",
            "return-object": false,
            clearable: "",
            "hide-details": "",
            density: "compact",
            class: "my-1",
            "data-cy": `cf-${field.id}-user-${item.id}`
          }, null, 8, ["model-value", "onUpdate:modelValue", "items", "data-cy"])) : _createCommentVNode("", true)], 64))])
        };
      })]), 1032, ["headers", "items", "height"])])], 512), [[_vShow, activePageTab.value === 'customFields' && !companyUserState.loading]])])])], 64);
    };
  }
};